<template>
  <div class="project_record">
    <el-card>
      <div class="project_record_color">
        <div class="project_record_color_left">
          <el-image :src="proObj.companyLogoKey" />
        </div>
        <div class="project_record_color_right">
          <p>
            {{ proObj.corporateName }}
            <span>[{{ proObj.itemNo }}]</span>
          </p>
          <div class="title">
            <span>项目简介:</span>
            {{ proObj.recruitmentPosition }}
          </div>
        </div>
      </div>
      <div class="project_record_table">
        <div class="project_record_table_left">
          <el-steps :active="stepNum" align-center finish-status="success">
            <el-step :title="step.preparation" :description="step.preparationTime"></el-step>
            <el-step :title="step.talentMapping" :description="step.talentMappingTime"></el-step>
            <el-step :title="step.interview" :description="step.interviewTime"></el-step>
            <el-step :title="step.offerNegotiate" :description="step.offerNegotiateTime"></el-step>
            <el-step :title="step.followUp" :description="step.followUpTime"></el-step>
            <el-step :title="step.complete" :description="step.completeTime"></el-step>
          </el-steps>
        </div>
        <div class="project_record_table_right">
          <el-table
            :data="proList"
            style="width: 100%"
            border
            :header-cell-style="{ fontSize: '16px', color: '#333' }"
          >
            <el-table-column
              label="项目顾问"
              prop="consultantName"
              align="center"
            ></el-table-column>
            <el-table-column label="工作时间" prop="totalTime" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="project_record_btn">
        <el-button type="primary" @click="addClick">添加项目记录</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column label="项目阶段" prop="projectPhase" align="center"></el-table-column>
        <el-table-column label="项目详况" align="center">
          <template v-slot="{ row }">
            <p>
              {{ row.projectDetails }}
              <a target="_blank" :href="row.fileKey" v-if="row.fileKey"
                ><i class="el-icon-paperclip"></i>附件</a
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作顾问" prop="consultant" align="center"></el-table-column>
        <el-table-column label="更新时间" prop="createTime" align="center"></el-table-column>
        <el-table-column class="operation" width="120" label="操作" align="center">
          <template v-slot="{ row }">
            <div class="operation_bottom">
              <dic-button @buttonClick="editItem(row)" icon="icon-jr-icon-modify" text="编辑" />
              <dic-button @buttonClick="deleteItem(row)" icon="icon-jr-icon-delete" text="删除" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_nation">
        <el-pagination
          :current-page="queryInfo.pageNum"
          :page-sizes="[30, 50, 100]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <el-dialog
        :title="dialogType == 1 ? '编辑项目记录' : '添加项目记录'"
        :visible.sync="dialogVisible"
        width="40%"
        @close="handleClose"
      >
        <el-form
          ref="form"
          :rules="rules"
          style="margin-top: 20px"
          :model="recordFrom"
          label-width="120px"
        >
          <div class="form_flex">
            <el-form-item label="项目阶段：" prop="projectPhase">
              <el-select
                @change="optionChange"
                v-model="recordFrom.projectPhase"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作顾问：" prop="consultant">
              <!-- <p>{{ recordFrom.consultant }}</p> -->
              <div class="fless">
                <!-- <div v-if="dialogType == 0">
                  <el-input v-model="operateInput" placeholder="请输入"></el-input>
                </div>
                <div v-if="dialogType == 1">
                  <el-input v-model="recordFrom.consultant" placeholder="请输入"></el-input>
                </div> -->
                <el-input v-model="recordFrom.consultant" placeholder="请输入"></el-input>
                <upload-file :lookUrl.sync="recordFrom.file" :saveUrl.sync="recordFrom.fileKey" />
              </div>
            </el-form-item>
          </div>
          <el-form-item label="是否入职：" v-if="itemShow">
            <el-radio-group v-model="recordFrom.isEntry">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="薪资待遇：">
            <upload-file :lookUrl.sync="recordFrom.file" :saveUrl.sync="recordFrom.fileKey" />
          </el-form-item> -->
          <div class="new_menoy">
            <div class="new_menoy_title">薪资待遇：</div>
            <el-form-item class="new_left">
              <div class="menony_flex">
                <div class="menony_flex_left">
                  <div class="menony_flex_item">
                    <span>年薪：</span>
                    <el-input v-model="recordFrom.annualSalary" />
                  </div>
                </div>
                <div class="menony_flex_center">
                  <span>薪资构成</span>
                  <div></div>
                </div>
                <div class="menony_flex_right">
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>固定月薪：</span>
                      <el-input v-model="recordFrom.monthlySalary" />
                    </div>
                    <div class="menony_flex_item">
                      <span>年度奖金：</span>
                      <el-input v-model="recordFrom.annualBonus" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>绩效奖金：</span>
                      <el-input v-model="recordFrom.performanceBonus" />
                    </div>
                    <div class="menony_flex_item">
                      <span>提成：</span>
                      <el-input v-model="recordFrom.commission" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_right_li_item">
                      <span>其他：</span>
                      <el-input v-model="recordFrom.other" type="textarea" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="项目详况：" prop="projectDetails">
            <el-input v-model="recordFrom.projectDetails" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
const defaultrecordObj = {
  annualSalary: '',
  monthlySalary: '',
  annualBonus: '',
  performanceBonus: '',
  other: '',
  commission: '',
  consultant: '',
  createName: '',
  createTime: '',
  file: '',
  fileKey: '',
  isEntry: '',
  projectDetails: '',
  projectId: '',
  projectPhase: ''
}
import { codeType } from '@/api/common.js'
import { pagination } from '@/mixins/pagination'
import { getProjectCenterById } from '@/api/projectCenter.js'
import {
  projectStep,
  projectTime,
  projectRecordList,
  updataProjectRecord,
  addProjectRecord,
  oneProjectRecord,
  deleteProjectRecord
} from '@/api/projectRecord.js'
import DicButton from '../../../../components/DicButton.vue'
import UploadFile from '../../../../components/UploadFile.vue'
export default {
  components: { DicButton, UploadFile },
  name: 'projectRecord',
  mixins: [pagination],
  data() {
    return {
      itemShow: false,
      options: [], //项目阶段数据
      recordFrom: { ...defaultrecordObj },
      rules: {
        projectPhase: [{ required: true, message: '请选择项目阶段', trigger: 'change' }],
        projectDetails: [{ required: true, message: '请输入项目详况', trigger: 'blur' }]
      }, //验证规则
      dialogType: 0,
      dialogVisible: false,
      queryInfo: {
        pageNum: 0,
        pageSize: 10,
        projectId: '' //id
      }, //查询条件
      tableData: [], //查询一览带分页数据
      proObj: {
        itemNo: '', //项目编号
        companyLogoKey: '', //头像
        corporateName: '', //公司名字
        recruitmentPosition: '' //项目简介
      },
      proList: [], //表格数据
      step: {}, //项目进度
      stepNum: 0, //项目进度步骤
      operateInput: '' // 操作顾问
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.projectOne() //查询项目
    this.projectStepList() //项目进度
    this.projectConsultant() //项目顾问
    this.search() //一览查询带分页
    this.codePro() //查询项目阶段的code表
    this.recordFrom.consultant = sessionStorage.getItem('userName')
  },
  methods: {
    addClick() {
      this.dialogType = 0
      this.dialogVisible = true
      this.dialogVisibleType = 0
      this.recordFrom.consultant = sessionStorage.getItem('userName')
    },
    //查询项目阶段的code表
    async codePro() {
      const { data: res } = await codeType({ code: '005' })
      if (res.resultCode === 200) {
        this.options = res.data
      }
    },
    //选择项目阶段
    optionChange(val) {
      if (val === '已完成') {
        this.itemShow = true
      } else {
        this.itemShow = false
      }
    },
    //新增编辑确定
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res
          if (this.dialogType) {
            this.recordFrom.consultant = sessionStorage.getItem('userName')
            res = await updataProjectRecord(this.recordFrom)
          } else {
            this.recordFrom.projectId = this.id
            res = await addProjectRecord(this.recordFrom)
          }
          if (res.data.resultCode === 200) {
            this.$message.success(`${this.dialogType ? '编辑' : '新增'}成功`)
            this.dialogVisible = false
            this.search()
            this.projectStepList()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    //关闭弹窗
    handleClose() {
      this.$refs.form.resetFields()
      Object.assign(this.recordFrom, defaultrecordObj)
      if (!this.dialogType) {
        this.recordFrom.consultant = sessionStorage.getItem('userName')
      }

      this.dialogVisible = false
      this.itemShow = false
    },
    //编辑
    async editItem(row) {
      const { data: res } = await oneProjectRecord({ id: row.id })
      if (res.resultCode === 200) {
        this.dialogType = 1
        this.dialogVisible = true
        Object.assign(this.recordFrom, res.data)
        if (this.recordFrom.isEntry === '1') {
          this.itemShow = true
        } else {
          this.itemShow = false
        }
      }
    },
    //删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteProjectRecord({ id: row.id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //一览查询带分页
    async search() {
      this.queryInfo.projectId = this.id
      const { data: res } = await projectRecordList(this.queryInfo)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    //项目顾问
    async projectConsultant() {
      const { data: res } = await projectTime({ projectId: this.id })
      if (res.resultCode === 200) {
        this.proList = res.data.projectTimeResults
      }
    },
    //获取项目进度
    async projectStepList() {
      const { data: res } = await projectStep({ projectId: this.id })
      if (res.resultCode === 200) {
        this.step = res.data
        if (this.step.isComplete) {
          this.stepNum = 6
        } else if (this.step.isFollowUp) {
          this.stepNum = 5
        } else if (this.step.isOfferNegotiate) {
          this.stepNum = 4
        } else if (this.step.isInterview) {
          this.stepNum = 3
        } else if (this.step.isTalentMapping) {
          this.stepNum = 2
        } else if (this.step.isPreparation) {
          this.stepNum = 1
        }
      }
    },
    //当前项目根据id
    async projectOne() {
      const { data: res } = await getProjectCenterById({ id: this.id })
      if (res.resultCode === 200) {
        this.proObj = res.data.projectCenterResult
      }
    }
  }
}
</script>

<style lang="less" scoped>
.project_record {
  width: 100%;
  .fless {
    width: 100%;
    display: flex;

    /deep/.el-input {
      width: 200px;
      margin-right: 60px;
    }
    /deep/.el-input__inner {
      width: 200px;
    }
  }

  .form_flex {
    // display: flex;
    // flex-direction: row;
    // align-items: center;
    overflow: hidden;

    /deep/.el-form-item {
      width: 50%;
    }
  }

  /deep/ .el-step__head.is-success {
    color: #17757a;
    border-color: #17757a;
  }

  /deep/ .el-step__title.is-success {
    color: #17757a;
  }

  /deep/ .el-step__description.is-success {
    color: #000;
  }

  .project_record_btn {
    margin: 20px 0;
  }

  .page_nation {
    width: 100%;
    margin: 40px auto 0 auto;
    text-align: center;
  }

  .project_record_color {
    box-sizing: border-box;
    padding: 16px;
    background-color: #17757a;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .project_record_color_left {
      width: 94px;
      height: 88px;
      overflow: hidden;
      margin-right: 12px;
    }

    .project_record_color_right {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      p {
        color: #fff;
        font-size: 18px;

        span {
          color: #ffea7a;
          font-size: 16px;
          margin-left: 6px;
        }
      }

      .title {
        color: #ffffff;
        font-size: 14px;
        line-height: 1.5em;
        margin-top: 12px;

        span {
          font-size: 16px;
        }
      }
    }
  }

  .project_record_table {
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow: hidden;
    margin-top: 32px;

    .project_record_table_left {
      flex: 1;
      overflow: hidden;
      box-sizing: border-box;
      padding: 20px 40px;
    }

    .project_record_table_right {
      width: 30%;
      overflow: hidden;
    }
  }
  .new_left {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .new_menoy_title {
    width: 120px;
    text-align: right;
    color: #606266;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .menony_flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .menony_flex_item {
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        display: block;
        color: #606266;
        font-size: 14px;
        width: 80px;
        text-align: right;
      }

      /deep/ .el-input {
        width: 135px;
      }
    }

    .menony_flex_left {
      margin-right: 40px;
      overflow: hidden;
      width: 18%;
    }

    .menony_flex_center {
      width: 12%;
      margin-right: 40px;
      font-size: 14px;
      align-items: center;
      color: #000;
      display: flex;
      flex-direction: column;

      /deep/ span {
        line-height: 20px !important;
      }

      div {
        width: 100%;
        position: relative;
        height: 2px;
        margin-top: 8px;
        background-color: #eee;
      }
      div:before {
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -4px;
        content: ' ';
        display: inline-block;
        height: 6px;
        width: 6px;
        border-width: 2px 2px 0 0;
        border-color: #c8c8cd;
        border-style: solid;
        -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
      }

      div:after {
        content: ' ';
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        bottom: 0;
        border-right: 1px solid #d9d9d9;
        color: #d9d9d9;
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
        -webkit-transform: scaleX(0.5);
        transform: scaleX(0.5);
      }
    }

    .menony_flex_right {
      flex: 1;
      overflow: hidden;

      /deep/ .el-input {
        width: 184px !important;
      }

      .menony_flex_right_li {
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
        // justify-content: space-between;
      }

      .menony_flex_right_li_item {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        span {
          display: block;
          color: #606266;
          font-size: 14px;
          width: 80px;
          text-align: right;
        }

        /deep/ .el-textarea {
          flex: 1;
        }
      }
    }
  }

  /deep/ .el-dialog {
    width: 967px !important;
  }
  /deep/ .el-textarea__inner {
    line-height: 1;
  }
}
</style>
